/**
 * internal dependencies
 */
import { VEHICLE_POOL_FORM } from "../form-cardgroup-types";
import { showToast } from "../../../toasts";
import PostVehiclePin from "../../../../routes/post-vehicle-pins";

/**
 * Updates the vehicle pin pool for a card group and calls the function to send the data
 * to the server.
 * 
 * @returns void
 */
const UpdateVehiclePins = () => {
  const vpForm = VEHICLE_POOL_FORM.vpForm;
  const vpActive = VEHICLE_POOL_FORM.vpActive;
  const vpFieldContainer = VEHICLE_POOL_FORM.vpFieldContainer;
  const vpSubmitButton = VEHICLE_POOL_FORM.vpSubmitButton;
  const vpCardGroupName = VEHICLE_POOL_FORM.vpCardGroupName;

  const postAndRedirect = async (awsData: any, cardGroupId: string) => {
    const { statusCode } = await PostVehiclePin(awsData);
    if ( statusCode === 200 ) {
      showToast('aafp_toast', `Pin Pool has been updated`);
      setTimeout(() => {
        location.href = `/card-group/edit-card-group/?groupAction=edit&groupID=${cardGroupId}`;
      }, 2000);
    }
  };

  vpForm.addEventListener('submit', async event => {
    let hasPin: boolean = true;
    let pinCount = vpFieldContainer.children.length;

    if ( vpActive.checked && pinCount === 0 ) {
      hasPin = false;
    }
    
    if ( vpForm.checkValidity() && hasPin ) {
      event.preventDefault();
      vpForm.classList.remove('was-validated');
      vpForm.classList.remove('form-control:valid');
      vpSubmitButton.classList.add('aafp_button-loading');

      let getPin = document.querySelectorAll<HTMLElement>('[data-pin-number]');
      let cardGroupId = vpCardGroupName.getAttribute('data-card-group-id')!;
      let pinData: string = '';
      let pinValues: Set<string> = new Set();
      let duplicatePin: boolean = false;

      getPin.forEach(pin => {
        let pinValue = pin.querySelector('[data-pin]') as HTMLInputElement;
        let pinDesc = pin.querySelector('.pin-desc') as HTMLInputElement;
        let pinValueText = pinValue.value.trim();

        if ( pinValues.has(pinValueText) ) {
          duplicatePin = true;
          showToast('aafp_toast-alert', `Duplicate pin number found: ${pinValueText}`);
          return;
        }

        pinValues.add(pinValueText);
        pinData += `${pinValueText}|${pinDesc.value === '' ? null : pinDesc.value},`;
      });

      if ( duplicatePin ) {
        vpSubmitButton.classList.remove('aafp_button-loading');
        return;
      }

      const awsJsonData = {
        cardGroupId: +cardGroupId,        
        vehiclePoolFlag: vpActive.checked ? 1: 0,
        vehicles: pinData.slice(0, -1)        
      };

      postAndRedirect(awsJsonData, cardGroupId);
    } else {
      event.preventDefault();
      event.stopPropagation();
      vpForm.classList.add('was-validated');
      if (pinCount === 0) {
        showToast('aafp_toast-alert', `Please add at least one pin number`);
      }
    }
  });
};

export default UpdateVehiclePins;